import styled from 'styled-components';

export const SwiperDefaultBox = styled.div`
    /** This overflow hidden solves a problem with live video streaming on right-to-left languages
    Without it, the IntersectionObserver does not work correctly and a weird behavior happens:
    The first video flicker like it is intersecting and transforms from scale(0.7) to scale(1) but in that process it loses intersection (ratio>0.99) and transforms back
    And again and again, an infinite flicker */
    overflow: hidden;
`;